module.exports = __webpack_public_path__ + "static/contact-ecc3e464c4699a9f848395cf775cb7f8.gif";